@if (!readonly && review) {
  <div>
    <div class="row" style="margin-bottom: 1em;">
      @if (kind === 0) {
        <h4>
          Write a review of <em>{{ reservation?.renter?.firstName }} {{ reservation?.renter?.lastName }}</em> based on their visit to
          <em>{{ reservation?.listing?.title }}</em
            >.
          </h4>
        }
        @if (kind === 1) {
          <h4>
            Write a review of you recent trip to <em>{{ reservation?.listing?.title }}</em>
          </h4>
        }
      </div>
      <form (ngSubmit)="onSubmit()">
        <div class="form-group">
          <label for="rating">Rating (5 being the best)</label>
          <select class="form-control" required [(ngModel)]="review.rating" name="rating" id="rating">
            <option value=""></option>
            @for (r of ratings; track r) {
              <option [ngValue]="r">{{ r }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label for="text">Comments</label>
          <textarea
            required
            name="text"
            id="text"
            type="textarea"
            class="form-control"
            rows="9"
            [(ngModel)]="review.text"
            spellcheck="true"
          ></textarea>
        </div>
        <div class="panel">
          <div class="panel-title">Please adhere to the following guidlines:</div>
          <div class="panel-body">
            <ul>
              <li>Do not including personal information (for example your mailing address).</li>
              <li>Do not use use profane or foul language.</li>
            </ul>
            <aside><b>Note</b>: This review will not be visible until it has been approved.</aside>
          </div>
        </div>
        <div class="form-group">
          <button type="submit" class="btn {{ mode === 'create' ? 'btn-primary' : 'btn-secondary' }}" [disabled]="waiting">
            {{ mode === "create" ? "Submit Review" : "Update Review" }}
          </button>
        </div>
      </form>
    </div>
  }
  @if (readonly) {
    <div>
      <div class="form-group-lg row">
        <rating-display name="rating" [rating]="review.rating"></rating-display>
      </div>
      <hr />
      <div class="form-group-lg row">
        <p class="form-control-static">
          {{ $safeNavigationMigration(review?.text) | newlineToBr }}
        </p>
      </div>
    </div>
  }
